import { hbs } from 'ember-cli-htmlbars';
export default hbs("<input class={{unless @classless \"tpk-input-input\"}} id={{@guid}} type={{@type}} value={{@value}} {{on @changeEvent @onChange}} ...attributes />")